import { STATUS } from "api/status";
import { handleError, showSuccess, showWarning } from "./utils";

export const createPayment = ({ stripeToken, subscriptionPlan, email, numberOfSubs, coupon }) => handleError(async (dispatch, getState, { api }) => {
  const response = await api.createSubscription({ coupon, stripeToken, subscriptionPlan, email, numberOfSubs });

  if(response === STATUS.success) {
    showSuccess({ text: 'Subscription renewed!' });
  } else {
    showWarning({ text: "Payment failed. You haven't been charged."} );
  }

  return STATUS.success;
}, 'An error occurred during renew');

export const createPaymentAndSignUp = ({ stripeToken, subscriptionPlan, password, email, numberOfSubs, coupon, ...userInfo }) => handleError(async (dispatch, getState, { api }) => {
    let response = await api.signup({ password, numberOfSubs, subscriptionPlan, email, ...userInfo });
    if (response === STATUS.success) {
      response = await api.createSubscription({ coupon, stripeToken, subscriptionPlan, email, numberOfSubs })
    }

    if(response === STATUS.success) {
      showSuccess({ text: 'Account Created!' });
    } else {
      showWarning({ text: "Payment failed. You haven't been charged."} );
    }

    return STATUS.success;
  }, 'An error occurred during registration');

  export const getDiscount = (coupon) => handleError(async (dispatch, getState, { api }) => {
    const response = await api.validateCoupon(coupon);
    return response 
  }, 'Coupon Not Found');
